import {ConnectedComponent} from 'lowkey-component'
import {sleep} from '@lib/utils'
import {appSelectors} from '@store/appSlice'

export class FirstViewElement extends ConnectedComponent<HTMLDivElement> {

  didMount() {

    this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
      if (status === 'hidingAnimation') {
        await sleep(100)
        this.element.classList.add('viewed')
      }
    })

    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        await sleep(100)
        this.element.classList.add('viewed')
      }
    })

  }
}
